import { customAlphabet } from 'nanoid';
import {
  MAIN_CONTAINER,
  NO_CLICK_CLASS,
  TRANSLATIONS_KEY,
  LOGIN_TOKEN_NAME,
  PARENT_COOKIE,
  GAME_COOKIE,
  PARENT_COOKIE_SECURE,
  GAME_COOKIE_SECURE,
  GUEST_USER_INFO,
  ROOT_ELEMENT,
  QUIZ_ID_DATA_ATTR,
  QUIZ_TYPE_DATA_ATTR,
  QUIZ_TYPE_DAILY
} from './constants';

/* 
    Returns the result of the API call.
*/
export const extractResult = async (resp) => {
  const result = await resp.json();
  if (result?.Data?.Value) {
    return result?.Data?.Value;
  }
  throw new Error(resp.statusText);
};

/* 
    Returns the translation for the given key.
    If the translation is not found, the defaultValue is returned.
*/
export const getTranslations = (key, defaultValue) => {
  const translation = window[TRANSLATIONS_KEY];
  return translation[key] ?? defaultValue;
};

/* 
    Returns the user's GUID.
    If the user is not logged in, a random GUID is returned.
*/
export const getUserGUID = () => {
  try {
    // return JSON.parse(localStorage.getItem(LOGIN_TOKEN_NAME))?.userguid;
    const gameUserGuid = JSON.parse(getGameLoginCookie());
    return gameUserGuid ? gameUserGuid?.GUID : Date.now();
  } catch (error) {
    return Date.now();
  }
};

export const isUserLoggedIn = () => {
  // const token = JSON.parse(localStorage.getItem(LOGIN_TOKEN_NAME))?.userguid;
  // return !!token; // Returns true if token exists, false otherwise

  const parentCookie = getParentLoginCookie();
  const gameCookie = getGameLoginCookie();

  return parentCookie && gameCookie ? true : false;
};

export const getUserToken = () => {
  const storedData = localStorage.getItem(LOGIN_TOKEN_NAME);
  if (!storedData) return null;

  try {
    const parsedData = JSON.parse(storedData);
    return parsedData.token;
  } catch (error) {
    console.error('Failed to parse stored data:', error);
    return null;
  }
};
export const getLoginPayload = () => {
  // const payload = {
  //   opttype: 1,
  //   platformid: 1,
  //   userid: 1003,
  //   socialid: '1003',
  //   gigyaid: '83643752ddd04d689dd99c5c2b6ee507',
  //   fullname: 'Test User',
  //   countrycode: null,
  //   favteamcode: null,
  //   profilepic: '',
  //   favteamid: null,
  //   level: '0',
  //   levelname: 'Novice',
  //   clientid: 1,
  //   gameplaydetail: []
  // };

  const guestUserInfo = getGuestUserInfoFromLocalStorage();
  const guestUserPlayedQuizzes = (guestUserInfo && guestUserInfo?.hasPlayed) || null;

  const payload = {
    QuizMasterIds: guestUserPlayedQuizzes
  };

  return payload;
};

/* 
    Replaces the placeholders in the given string with the values from the given object.
 */
export const replacePlaceholder = (input, replaceObj) => {
  const pattern = /\{([^}]+)\}/g;

  function replacer(str) {
    return str.replace(pattern, (match, key) => {
      return replaceObj.hasOwnProperty(key) ? replaceObj[key] : match;
    });
  }

  if (typeof input === 'string') {
    return replacer(input);
  }

  if (Array.isArray(input)) {
    return input.map((item) => {
      if (typeof item === 'string') {
        return replacer(item);
      }
      if (typeof item === 'object' && item !== null) {
        return replacePlaceholder(item, replaceObj);
      }
      return item;
    });
  }

  if (typeof input === 'object' && input !== null) {
    return Object.keys(input).reduce((acc, key) => {
      if (typeof input[key] === 'string') {
        acc[key] = replacer(input[key]);
      } else if (typeof input[key] === 'object') {
        acc[key] = replacePlaceholder(input[key], replaceObj);
      } else {
        acc[key] = input[key];
      }
      return acc;
    }, {});
  }

  return input;
};
export const getCurrentRoute = (pathname) => {
  const routeParts = pathname.split('/');
  return routeParts[routeParts.length - 1];
};

const ONE_DAY = 24 * 60 * 60 * 1000; // Milliseconds in one day
const ONE_HOUR = 60 * 60 * 1000; // Milliseconds in one hour
const ONE_MINUTE = 60 * 1000; // Milliseconds in one minute
const ONE_SECOND = 1000; // Milliseconds in one second

export const getTimeLeft = (currentUTC, targetUTC) => {
  const difference = targetUTC.getTime() - currentUTC.getTime();

  if (difference <= 0) {
    return null;
  }

  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

  return { days, hours, minutes };
};


export const getTimeLeftForNextQuiz = (now) => {
  const nextQuizDate = new Date(now);
  nextQuizDate.setUTCDate(nextQuizDate.getUTCDate() + 1);
  nextQuizDate.setUTCHours(0, 0, 0, 0); // Set to 12 AM UTC

  const nextQuizTime = nextQuizDate.getTime();

  const distance = nextQuizDate.getTime() - now;

  const days = Math.floor(distance / ONE_DAY);
  const hours = Math.floor((distance % ONE_DAY) / ONE_HOUR);
  const minutes = Math.floor((distance % ONE_HOUR) / ONE_MINUTE);
  const seconds = Math.floor((distance % ONE_MINUTE) / ONE_SECOND);

  return { days, hours, minutes, seconds, nextQuizTime };
};

export const handleNativeShare = async ({ title, text, url }) => {
  if (navigator.share) {
    await navigator.share({
      title,
      text,
      url
    });
  } else false;
};

export const openWindow = (url, height = 800, width = 600) => {
  window.open(
    url,
    '',
    `left=0,top=0,menubar=0,resizable=0,toolbar=0,status=1,scrollbars=0,width=${width},height=${height}`
  );
};

export const generateUniqueId = () => {
  const digits = '0123456789';
  const nanoid = customAlphabet(digits, 12);
  return `-${nanoid()}`;
};
export const noClickLoader = (load = false) => {
  if (load) {
    document.querySelector(MAIN_CONTAINER)?.classList?.add(NO_CLICK_CLASS);
  } else {
    document.querySelector(MAIN_CONTAINER)?.classList?.remove(NO_CLICK_CLASS);
  }
};

export const serialize = (data) => {
  if (!data) return;
  return typeof data === 'string' ? data : JSON.stringify(data);
};

export async function wait(sleep) {
  return new Promise((resolve) => {
    setTimeout(resolve, sleep);
  });
}

export function getOrdinalSuffix(number) {
  if (typeof number !== 'number' || !Number.isInteger(number)) {
    return null;
  }

  const remainder10 = number % 10;
  const remainder100 = number % 100;

  if (remainder100 >= 11 && remainder100 <= 13) {
    return number + 'th';
  }

  switch (remainder10) {
    case 1:
      return number + 'st';
    case 2:
      return number + 'nd';
    case 3:
      return number + 'rd';
    default:
      return number + 'th';
  }
}

export function getCookie(name) {
  let cookieArr = document.cookie.split(';');

  for (let i = 0; i < cookieArr.length; i++) {
    let cookiePair = cookieArr[i].split('=');

    // Removing whitespace at the beginning of the cookie name and compare it with the given string
    if (name === cookiePair[0].trim()) {
      // Decode the cookie value and return
      return decodeURIComponent(cookiePair[1]);
    }
  }

  // Return null if not found
  return null;
}

export function getParentLoginCookie() {
  return getCookie(PARENT_COOKIE);
}

export function getGameLoginCookie() {
  return getCookie(GAME_COOKIE);
}

export function deleteCookie(name) {
  // Set the cookie with a past expiration date
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

export function deleteAllLoginCookies() {
  deleteCookie(PARENT_COOKIE);
  deleteCookie(PARENT_COOKIE_SECURE);
  deleteCookie(GAME_COOKIE_SECURE);
  deleteCookie(GAME_COOKIE);
}

export const getGuestUserInfoFromLocalStorage = () => {
  const storedGuestUserInfo = localStorage.getItem(GUEST_USER_INFO);
  const parsedGuestUserInfo = storedGuestUserInfo ? JSON.parse(storedGuestUserInfo) : null;
  return parsedGuestUserInfo;
};

export const redirectToLogin = (cbPath = '/quizzes/daily-quiz') => {
  window.location.href = `/login?cbkurl=${cbPath}`;
};

export function isArraysEqual(arr1, arr2) {
  // Check if lengths are equal
  if (arr1.length !== arr2.length) {
    return false;
  }

  // Check if all elements are equal
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
}

export const isTopicalQuiz = () => {
  return document.querySelector('.' + ROOT_ELEMENT).getAttribute(QUIZ_ID_DATA_ATTR);
};
export const embedQuizType = () => {
  const quizType = document.querySelector('.' + ROOT_ELEMENT)?.getAttribute(QUIZ_TYPE_DATA_ATTR);
  return quizType || QUIZ_TYPE_DAILY;
};
